import { ScimWizardProvider } from "../../../../providers/ScimWizardProvider";

import ScimWizard from "./ScimWizard";

export default function ScimWizardWithProvider() {
	return (
		<ScimWizardProvider>
			<ScimWizard />
		</ScimWizardProvider>
	);
}
